import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { 
  LayoutDashboard, 
  Tv, 
  Monitor, 
  Settings, 
  LogOut,
  Globe
} from 'lucide-react';

const Sidebar = () => {
  const { provider, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/devices', icon: Monitor, label: 'Devices' },
    { to: '/portal', icon: Globe, label: 'Portal Settings' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="flex items-center gap-3 px-2 mb-8">
        <div className="w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center">
          <Tv className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h1 className="font-bold text-white text-lg">STB Manager</h1>
          <p className="text-xs text-muted-foreground">Control Panel</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
            className={({ isActive }) =>
              `sidebar-item ${isActive ? 'active' : ''}`
            }
          >
            <Icon className="w-5 h-5" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Provider Info & Logout */}
      <div className="border-t border-border pt-4 mt-4">
        <div className="px-2 mb-4">
          <p className="text-sm font-medium text-foreground truncate">
            {provider?.company_name}
          </p>
          <p className="text-xs text-muted-foreground truncate">
            {provider?.email}
          </p>
        </div>
        <button
          data-testid="logout-button"
          onClick={handleLogout}
          className="sidebar-item w-full text-red-400 hover:text-red-300 hover:bg-red-500/10"
        >
          <LogOut className="w-5 h-5" />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
